import {
  GET_ERE_DETAIL_SUCCESS,
  GET_TRACKING_SUCCESS,
  SET_EPROMOTION_AM_CANDIDATE_ID,
  SET_LIST_OF_VALUE_DATA,
  SET_PRE_CANDIDATE_DETAIL_DATA,
  UPDATE_BY_PRE_CANDIDATE_SUCCESS,
} from './constants';

const date = new Date();

export const initialState = {
  eRecruitmentPendingData: [],
  eRecruitmentProcessedData: [],
  statusData: [],
  listOfValueData: [],
  preCandidateDetailData: {},
  register: null,
  checkDuplicatedPhone: null,
  createPostPresigned: false,
  postFile: null,
  tracking: null,
  files: [],
  updateByPreCandidate: null,
  checkStepCandidate: null,
  checkAppStatus: null,
  eReDetail: null,
  ePromotionAmCandidateId: null,
};

const ePromotionReducers = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_LIST_OF_VALUE_DATA:
      state = {
        ...state,
        listOfValueData: payload,
      };
      break;
    case GET_TRACKING_SUCCESS:
      state = {
        ...state,
        tracking: payload,
      };
      break;
    case UPDATE_BY_PRE_CANDIDATE_SUCCESS:
      state = {
        ...state,
        updateByPreCandidate: payload,
      };
      break;
    case GET_ERE_DETAIL_SUCCESS:
      state = {
        ...state,
        eReDetail: payload,
      };
      break;
    case SET_PRE_CANDIDATE_DETAIL_DATA:
      state = {
        ...state,
        preCandidateDetailData: payload,
      };
      break;
    case SET_EPROMOTION_AM_CANDIDATE_ID:
      state = {
        ...state,
        ePromotionAmCandidateId: payload,
      };
      break;

    default:
      break;
  }
  return state;
};

export default ePromotionReducers;
